import { render, staticRenderFns } from "./ReportPreanestecia.vue?vue&type=template&id=849c03c2&scoped=true"
import script from "./ReportPreanestecia.vue?vue&type=script&lang=js"
export * from "./ReportPreanestecia.vue?vue&type=script&lang=js"
import style0 from "./ReportPreanestecia.vue?vue&type=style&index=0&id=849c03c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849c03c2",
  null
  
)

export default component.exports